import type { AiCapabilityPage } from "../schema.js";
import { LIVE, OWNER_ADMIN } from "./_shared.js";

/**
 * `GRP-MEMBER-REMOVE` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/members` (ADR-0009 bất biến 5).
 * US-AIV2-0110 S10 (`@UC0259`): trước trỏ trang chủ nhóm `/groups/:groupId`; nay tab "Thành viên" — màn chi tiết thành viên cần `memberId` mà engine chưa điền được.
 * Cửa mobile trang này chịu trách nhiệm (hành động PHÁ HUỶ; `FinancialPositionService` chặn khi còn vị thế ⇒ người bấm cần đọc lý do trên màn).
 */
export const GRP_MEMBER_REMOVE = {
  id: "GRP-MEMBER-REMOVE",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: OWNER_ADMIN,
  flags: [],
  slots: [],
  llm: {
    description: "Cho một người ra khỏi nhóm.",
    examples: [
      "xoá thành viên khỏi nhóm",
      "xoa thanh vien khoi nhom",
      "cho bạn đó ra khỏi nhóm",
      "kick khỏi nhóm",
      "bỏ người này ra",
      // ——— 0105: thêm cho đủ 40 ———
      "cho ban do ra khoi nhom",
      "kick khoi nhom",
      "bo nguoi nay ra",
      "loại một thành viên ra khỏi nhóm",
      "loai mot thanh vien ra khoi nhom",
      "đuổi người đó khỏi nhóm",
      "duoi nguoi do khoi nhom",
      "xoá bạn ấy khỏi danh sách nhóm",
      "xoa ban ay khoi danh sach nhom",
      "gỡ một người ra khỏi nhóm",
      "go mot nguoi ra khoi nhom",
      "bạn ấy chuyển trường rồi, cho ra khỏi nhóm",
      "ban ay chuyen truong roi cho ra khoi nhom",
      "xoá suất của người đã nghỉ",
      "xoa suat cua nguoi da nghi",
      "người này không còn sinh hoạt nữa, bỏ ra",
      "nguoi nay khong con sinh hoat nua bo ra",
      "cho thành viên cũ ra",
      "cho thanh vien cu ra",
      "xoá người trong nhóm",
      "xoa nguoi trong nhom",
      "remove thành viên",
      "remove thanh vien",
      "bỏ bớt một người khỏi nhóm",
      "bo bot mot nguoi khoi nhom",
      "làm sao để cho một người ra khỏi nhóm?",
      "lam sao de cho mot nguoi ra khoi nhom",
      "loại người trùng tên bị thêm nhầm",
      "loai nguoi trung ten bi them nham",
      "mình muốn bỏ một thành viên khỏi nhóm",
      "minh muon bo mot thanh vien khoi nhom",
      "cho một phụ huynh ra khỏi nhóm lớp",
      "cho mot phu huynh ra khoi nhom lop",
      "xoá thành viên bị thêm trùng",
      "xoa thanh vien bi them trung",
    ],
  },
  screen: "/groups/:groupId/members",
  screenShows: "member_remove",
  endpoints: [
    "DELETE /groups/{groupId}/members/{memberId}",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở trang thành viên đó nhé. Người còn khoản chưa xong thì hệ thống sẽ chặn — chỗ đó nói rõ còn vướng gì.",
  },
  journey: { after: ["READ-PEOPLE-MINE"] },
  help: { title: "Cho người ra khỏi nhóm", tryNow: "xoá thành viên khỏi nhóm" },
} satisfies AiCapabilityPage;
